import React from 'react';
import './styles/section-our-work.css'

const SectionOurWork = () => {
  return (
    <section className='section-our-work comman_sec'>
      <div className='header-navbar-wrapper'>
                                <ul className="nav navbar-nav">
                                    <li><a href='/our-work'>Our Work</a></li>
                                </ul>
                            </div>
    </section>
  )
}

export default SectionOurWork